function ColouredBadge({colour, text}){
    return (
        <div className={`relative w-3/4 ${colour} rounded-full px-4 py-1 text-white font-bold flex flex-col justify-center items-center`}>
        {text}
        </div>
    )
}

export default ColouredBadge;